import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
export const triggerSatisfactionSurveysEndpoint = {
    [surveyEndpointIds.TRIGGER_SATISFACTION_SURVEYS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                userIds: { type: 'array',
                    items: {
                        type: 'string',
                    },
                },
            },
            required: ['userIds'],
        },
    },
};
